import { logger } from '@vista/omnichannel-components-domain';
import { MemberPaymentCardWalletFormActionType as ActionType } from './form-action-type';
import { MemberPaymentCardWalletFormLoadingState } from './form-state';
export const memberPaymentCardWalletFormActionReducer = (state, action) => {
    switch (action.type) {
        case ActionType.CloseModal:
            return Object.assign(Object.assign({}, state), { showModal: false });
        case ActionType.OpenModal:
            return Object.assign(Object.assign({}, state), { showModal: true, modalType: action.modalType });
        case ActionType.MakePrimaryChosen:
            return Object.assign(Object.assign({}, state), { makePrimaryChosen: true });
        case ActionType.LoadedPaymentCardsClient: {
            const { client } = action;
            return Object.assign(Object.assign({}, state), { loadingState: MemberPaymentCardWalletFormLoadingState.Success, paymentCardsClient: client });
        }
        case ActionType.SetError: {
            return Object.assign(Object.assign({}, state), { error: action.error });
        }
        case ActionType.AddPaymentCardStarted: {
            return Object.assign(Object.assign({}, state), { loadingState: MemberPaymentCardWalletFormLoadingState.AddingCard });
        }
        case ActionType.AddPaymentCardButtonStateChanged: {
            return Object.assign(Object.assign({}, state), { addPaymentCardButtonState: action.buttonState });
        }
        case ActionType.TermsAndConditionsAccepted: {
            return Object.assign(Object.assign({}, state), { termsAndConditionsAccepted: action.accepted });
        }
        case ActionType.TryAgainButtonClicked: {
            return Object.assign(Object.assign({}, state), { error: undefined, termsAndConditionsAccepted: false, addPaymentCardButtonState: { isDisabled: true } });
        }
        default: {
            logger.error(`Unknown MemberPaymentCardWalletFormAction ${action.type}.`);
            return state;
        }
    }
};
